import { useEffect, useState } from 'react';
import { Icon, Input } from '@repo/ui';
import { isValidEmail } from '@xtnd/web/shared/utils/validateEmail';

interface CcInputProps {
  readonly value: string[];
  readonly onChange: (emails: string[]) => void;
}

export const CcInput = ({ value, onChange }: CcInputProps) => {
  const [tags, setTags] = useState<string[]>([]);
  const [input, setInput] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setTags(value);
    setInput('');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setInput(val);

    if (val !== '' && !isValidEmail(val)) {
      setError('Invalid email');
    } else {
      setError(null);
    }
  };

  const handleBlur = () => {
    if (input && !isValidEmail(input)) {
      setError('Invalid email');
    } else if (input) {
      addTag();
    }
  };

  const addTag = () => {
    const email = input.trim();
    if (!email) return;
    if (!isValidEmail(email)) {
      setError('Invalid email');
      return;
    }
    setError(null);
    const newTags = [...tags, email];
    setTags(newTags);
    onChange(newTags);
    setInput('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', ',', ';'].includes(e.key)) {
      e.preventDefault();
      addTag();
    }
  };

  const removeTag = (index: number) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
    onChange(newTags);
  };

  return (
    <div className="flex flex-col gap-1">
      <label
        htmlFor="cc-input"
        className="text-sm font-medium text-xtnd-dark dark:text-xtnd-white"
      >
        CC
      </label>

      <div
        className={`flex flex-wrap items-center gap-2 px-1 py-1 border rounded-md ${
          error ? 'border-red-500' : 'border-gray-300'
        } bg-white dark:bg-xtnd-dark`}
      >
        {tags.map((tag, idx) => (
          <span
            key={tag}
            className="flex items-center gap-1 bg-xtnd-blue-100 text-xtnd-dark px-2 py-1 rounded-md border border-xtnd-blue-200 dark:bg-xtnd-dark-800 dark:text-xtnd-white"
          >
            <span className="text-sm truncate max-w-[220px]">{tag}</span>

            <Icon
              size="sm"
              onClick={() => removeTag(idx)}
              name="HiOutlineX"
              className="cursor-pointer hover:text-red-400"
            />
          </span>
        ))}

        <Input
          className="min-w-64 h-8"
          value={input}
          type="email"
          placeholder="cc address"
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          onBlur={handleBlur}
        />

      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
